<template>
  <q-card v-if="show" style="margin-top:20px" square>
    <div class="result-title">
      <div class="title-text">Payment Schedule</div>
      <i class="fas fa-info" @click="showDetail = true">
        <q-tooltip>Detailed Payment Schedule</q-tooltip>
      </i>
      <i class="fas fa-times" style="margin-left:15px" @click="destroy">
        <q-tooltip>Close</q-tooltip>
      </i>
    </div>
    <div class="result-body">
      <div class="result" v-if="monthlyLeaseAmount">
        <span class="title">Monthly Lease Interest</span>
        <span class="val">{{monthlyLeaseAmount}}%</span>
      </div>
      <div class="result" v-if="payment">
        <span class="title">Monthly Lease Interest Payment</span>
        <span class="val">{{currencyConventer(payment)}}</span>
      </div>
      <div
        class="result"
        v-if="annualLease !== '' && annualLease !== null && annualLease !== undefined"
      >
        <span class="title">Annual Lease Interest</span>
        <span class="val">{{annualLease}}%</span>
      </div>
      <div
        class="result"
        v-if="annualLeaseNotPer !== '' && annualLeaseNotPer !== null && annualLeaseNotPer !== undefined"
      >
        <span class="title">Annual Lease Interest Payment</span>
        <span class="val">{{currencyConventer(annualLeaseNotPer)}}</span>
      </div>
      <div
        class="result"
        v-if="endLeaseTerm !== '' && endLeaseTerm !== null && endLeaseTerm !== undefined"
      >
        <span class="title">Pay Off Value at the end of Lease Term</span>
        <span class="val positive">{{currencyConventer(endLeaseTerm)}}</span>
      </div>
      
      <div class="result" v-if="monthlyPaymentFinance">
        <span class="title">Monthly Payment</span>
        <span class="val">{{currencyConventer(monthlyPaymentFinance)}}</span>
      </div>
      <div class="result" v-if="totalPaidEndOfFinance">
        <span class="title">Total Paid to Vehicle at end of period</span>
        <span class="val">{{currencyConventer(totalPaidEndOfFinance)}}</span>
      </div>
      <div class="result" v-if="totalInterestPaidEndFinance">
        <span class="title">Total Interest Paid at the of period</span>
        <span class="val">{{currencyConventer(totalInterestPaidEndFinance)}}</span>
      </div>
      <div
        class="result"
        v-if="balanceEndFinance !== null && balanceEndFinance !== '' && balanceEndFinance !== undefined"
      >
        <span class="title">Balance of Principle at end of period</span>
        <span class="val">{{currencyConventer(balanceEndFinance)}}</span>
      </div>
      <div class="result" v-if="residualValue">
        <span class="title">Payoff Value at the end of Lease Term</span>
        <span class="val">{{currencyConventer(residualValue)}}</span>
      </div>
      <div class="result" v-if="predictedResi">
        <span class="title">Predicted Residual Value</span>
        <span class="val">{{currencyConventer(predictedResi)}}</span>
      </div>
    </div>
  </q-card>
</template>

<script>
export default {
  computed: {
    predictedResi(){
      return this.$store.state.calculator.predictedResi
    },
    annualLeaseNotPer(){
      return this.$store.state.calculator.annualLeaseNotPer
    },
    showDetail:{
      get(){
        return this.$store.state.calculator.showDetail
      },
      set(val){
        this.$store.commit('calculator/SHOW_DETAILED',val)
      }
    },
    method() {
      return this.$store.state.calculator.method;
    },
    annualLease(){
      return this.$store.state.calculator.annualLease
    },
    type() {
      return this.$store.state.calculator.type;
    },
    balanceEndFinance() {
      return this.$store.state.calculator.balanceEndFinance;
    },
    totalInterestPaidEndFinance() {
      return this.$store.state.calculator.totalInterestPaidEndFinance;
    },
    totalPaidEndOfFinance() {
      return this.$store.state.calculator.totalPaidEndOfFinance;
    },
    monthlyPaymentFinance() {
      return this.$store.state.calculator.monthlyPaymentFinance;
    },
    residualValue() {
      return this.$store.state.calculator.residualValue;
    },
    payment() {
      return this.$store.state.calculator.payment;
    },
    currencyConventer() {
      return (val) =>
        val.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
    },
    show: {
      get() {
        return this.$store.state.calculator.show;
      },
      set(val) {
        this.$store.commit("calculator/SET_SHOW", val);
      },
    },
    monthlyLeaseAmount() {
      return this.$store.state.calculator.monthlyLeaseAmount;
    },
    endLeaseTerm() {
      return this.$store.state.calculator.endLeaseTerm;
    },
  },
  methods: {
    destroy() {
      this.show = false;
      this.$store.commit("calculator/RESET_VALS", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.result-title {
  display: flex;
  flex-flow: row nowrap;
  background-color: rgb(2, 123, 227);
  color: #fff;
  align-items: center;
  padding: 15px;
  .title-text {
    font-weight: 700;
    font-size: 20px;
    flex: 1;
  }
  i {
    cursor: pointer;
  }
}
.result-body {
  .result {
    padding: 15px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    font-weight: 700;
    .title {
      flex: 1;
    }
    .val {
      margin-left: 5px;
      padding: 5px;
      color: #fff;
      border-radius: 5px;
      background: crimson;
    }
  }
}
</style>